import { jsx as _jsx } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { Message } from '../../../subcomponents/message/message';
import { OrderPaymentFormContextInstance } from '../types/context';
export var OrderPaymentFormMessageType;
(function (OrderPaymentFormMessageType) {
    OrderPaymentFormMessageType["OrderCompletionFailed"] = "OrderCompletionFailed";
    OrderPaymentFormMessageType["PaymentFailed"] = "PaymentFailed";
    OrderPaymentFormMessageType["FailedToInitialiseConnector"] = "FailedToInitialiseConnector";
    OrderPaymentFormMessageType["FailedToLoadData"] = "FailedToLoadData";
    OrderPaymentFormMessageType["PaymentDeclined"] = "PaymentDeclined";
})(OrderPaymentFormMessageType || (OrderPaymentFormMessageType = {}));
const b = bemClassBuilder('v-order-payment-form-message');
export const OrderPaymentFormMessage = observer(props => {
    const { messageType, children } = props;
    const { assets, displayText } = useContext(OrderPaymentFormContextInstance);
    return (_jsx(Message, Object.assign({}, getOrderPaymentFormMessageProps(messageType, assets, displayText), { className: b.block({ type: messageType }) }, { children: children })));
});
OrderPaymentFormMessage.displayName = 'OrderPaymentFormMessage';
export const getOrderPaymentFormMessageProps = (messageType, assets, displayText) => {
    switch (messageType) {
        case OrderPaymentFormMessageType.OrderCompletionFailed:
            return {
                iconName: assets.orderCompletionFailedIconName,
                title: displayText.orderCompletionFailedTitle,
                description: displayText.orderCompletionFailedMessage
            };
        case OrderPaymentFormMessageType.PaymentFailed:
            return {
                iconName: assets.paymentFailedIconName,
                title: displayText.paymentFailedTitle,
                description: displayText.paymentFailedMessage
            };
        case OrderPaymentFormMessageType.FailedToInitialiseConnector:
            return {
                iconName: assets.failedToInitialiseConnectorIconName,
                title: displayText.failedToInitialiseConnectorTitle,
                description: displayText.failedToInitialiseConnectorMessage
            };
        case OrderPaymentFormMessageType.FailedToLoadData:
            return {
                iconName: assets.failedToLoadDataIconName,
                title: displayText.failedToLoadDataTitle,
                description: displayText.failedToLoadDataMessage
            };
        case OrderPaymentFormMessageType.PaymentDeclined:
            return {
                iconName: assets.paymentDeclinedIconName,
                title: displayText.paymentDeclinedTitle,
                description: displayText.paymentDeclinedMessage
            };
        default:
            return undefined;
    }
};
